import React from 'react';
import useApi from './useApi';

const BASE_URL = '/user';

export const useUser = () => {
  const { get, post, put, remove: removeUser } = useApi();

  /** List all users */
  const list = React.useCallback(async () => {
    const users = await get(BASE_URL);
    return users;
  }, [get]);

  /** Load a user */
  const load = React.useCallback(
    async userId => {
      const loadedUser = await get(`${BASE_URL}/${userId}`);
      return {
        ...loadedUser,
        profile: {
          ...loadedUser.profile,
          label: loadedUser.profile.description,
        },
      };
    },
    [get],
  );

  /** Add a new user */
  const create = React.useCallback(
    async user => {
      const createdUser = await post(BASE_URL, user);
      return createdUser;
    },
    [post],
  );

  /** Update a new user */
  const update = React.useCallback(
    async (userId, user) => {
      const updatedUser = put(`${BASE_URL}/${userId}`, user);
      return updatedUser;
    },
    [put],
  );

  /** Remove a new user */
  const remove = React.useCallback(
    async userId => {
      const deletedUser = removeUser(`${BASE_URL}/${userId}`);
      return deletedUser;
    },
    [removeUser],
  );

  /** Check if username is available */
  const isLoginAvailable = React.useCallback(
    async username => {
      const result = get(`${BASE_URL}/${username}/is-avilable`);
      return result;
    },
    [get],
  );

  /** Change user password */
  const changePassword = React.useCallback(
    async (userId, data) => {
      const result = put(`${BASE_URL}/${userId}/change-password`, data);
      return result;
    },
    [put],
  );

  return {
    list,
    load,
    create,
    update,
    remove,
    isLoginAvailable,
    changePassword,
  };
};

export default useUser;
